export default __webpack_public_path__ + "static/media/PrintRuleFrontSideA6.2901a5a3.svg";